import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const PageFallbackButtons = styled(FocusNode)`
  display: flex;
`

export const PageFallbackText = styled.div`
  text-align: center;
  margin-bottom: 20px;
  font-size: 28px;
  line-height: 1.5;
`
export const PageFallbackWrapper = styled.div<{
  $width?: string
  $height?: string
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${({ $width }) => $width};
  height: ${({ $height = '100%' }) => $height};
`
